import { cn } from "../../lib/utils";

/**
 * TierBadge — small pill showing a subscription tier.
 *
 * Free  = slate (neutral)
 * Lite  = sky/indigo
 * Pro   = gold/amber gradient (premium)
 *
 * Unknown / missing tier falls back to "Free" so the badge never renders empty.
 */
const TIER_META = {
  free: {
    label: "Free",
    className:
      "bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
  },
  lite: {
    label: "Lite",
    className:
      "bg-sky-100 text-sky-700 ring-1 ring-inset ring-sky-200 dark:bg-sky-900/40 dark:text-sky-200 dark:ring-sky-800",
  },
  pro: {
    label: "Pro",
    className:
      "bg-gradient-to-r from-amber-200 to-yellow-300 text-amber-900 ring-1 ring-inset ring-amber-300 shadow-sm dark:from-amber-500/30 dark:to-yellow-500/30 dark:text-amber-100 dark:ring-amber-700/60",
  },
};

export function TierBadge({ tier, className }) {
  const meta = TIER_META[tier] || TIER_META.free;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        meta.className,
        className
      )}
      data-tier={meta.label.toLowerCase()}
    >
      {meta.label}
    </span>
  );
}

export default TierBadge;
